<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <p class="title">{{ i18n.roles[iso] }}</p>
      </div>
    </section>

    <!-- Create Role Button -->
    <div class="columns">
      <div class="column is-2">
        <b-button
          icon-left="plus"
          icon-pack="fas"
          type="is-success"
          @click="openModalCreateRole"
          expanded
          >Crear Rol</b-button
        >
      </div>
    </div>

    <!-- Filters -->
    <div class="columns is-multiline">
      <div class="column is-3">
        <b-field label="Nombre" label-position="on-border">
          <b-input
            v-model="filters.Nombre"
            placeholder="Nombre"
            type="search"
            icon="magnify"
            @input="findWithFilters"
          ></b-input>
        </b-field>
      </div>
      <!-- <div class="column is-3">
        <b-field label="Tipo" label-position="on-border">
          <b-select
            v-model="filters.Tipo"
            placeholder="Tipo"
            expanded
            @input="findWithFilters"
          >
            <option :value="null">Todos</option>
            <option value="system">Sistema</option>
            <option value="club">Club</option>
          </b-select>
        </b-field>
      </div> -->

      <!-- <div class="column is-3">
        <b-button
          icon-left="search"
          icon-pack="fas"
          type="is-info"
          @click="listRoles"
          expanded
          >Buscar</b-button
        >
      </div> -->
    </div>

    <b-table
      :data="systemRolesFiltered"
      :loading="loadingTableList"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :bordered="isBordered"
      :striped="isStriped"
      :narrowed="isNarrowed"
      :hoverable="isHoverable"
      :focusable="isFocusable"
      :mobile-cards="hasMobileCards"
    >
      <b-table-column field="Nombre" label="Nombre" v-slot="props">
        {{ props.row.Nombre }}
      </b-table-column>

      <b-table-column field="Tipo" label="Tipo" centered v-slot="props">
        <b-tag :type="getRoleTypeColor(props.row.Tipo)">
          {{ props.row.Tipo }}
        </b-tag>
      </b-table-column>

      <b-table-column field="Permisos" label="Permisos" centered v-slot="props">
        <b-button
          size="is-small"
          type="is-info is-light"
          @click="openViewPermissions(props.row)"
          >Ver Permisos</b-button
        >
      </b-table-column>

      <b-table-column field="Clubes" label="Clubes" centered v-slot="props">
        <b-button
          size="is-small"
          type="is-info is-light"
          @click="openViewClubs(props.row)"
          >Ver Clubes</b-button
        >
      </b-table-column>

      <b-table-column
        field="CreadoPor"
        label="CreadoPor"
        v-slot="props"
        centered
      >
        {{ props.row.CreadoPor }}
      </b-table-column>

      <b-table-column field="Activo" label="Estado" centered v-slot="props">
        <b-tag :type="props.row.Activo ? 'is-success' : 'is-danger'">
          {{ props.row.Activo ? "Activo" : "Inactivo" }}
        </b-tag>
      </b-table-column>

      <b-table-column label="Acciones" centered v-slot="props">
        <b-tooltip label="Editar" type="is-warning">
          <b-button
            type="is-warning is-light"
            icon-left="pen"
            icon-pack="fas"
            size="is-small"
            @click="openEditRole(props.row)"
            style="margin-right: 5px"
          ></b-button>
        </b-tooltip>
        <b-tooltip
          :label="props.row.Activo ? 'Inhabilitar' : 'Habilitar'"
          :type="props.row.Activo ? 'is-danger' : 'is-success'"
        >
          <b-button
            :type="
              props.row.Activo ? 'is-danger is-light' : 'is-success is-light'
            "
            :icon-left="props.row.Activo ? 'ban' : 'check'"
            icon-pack="fas"
            size="is-small"
            @click="toggleRoleStatus(props.row)"
          ></b-button>
        </b-tooltip>
      </b-table-column>

      <template #empty>
        <div class="has-text-centered">No hay roles disponibles</div>
      </template>
    </b-table>

    <!-- Modals -->
    <b-modal
      v-model="ModalCreateRole"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <template #default="props">
        <modal-create-role-system
          :roleToEdit="selectedRole"
          @refreshRoles="listRoles"
          @close="props.close"
        ></modal-create-role-system>
      </template>
    </b-modal>

    <b-modal
      v-model="isModalViewPermissionsActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      width="960"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title" style="font-size: large">
            Permisos del Rol
          </p>
          <button
            class="card-header-icon"
            aria-label="close"
            @click="isModalViewPermissionsActive = false"
          >
            <span class="icon">
              <i class="fas fa-times" aria-hidden="true"></i>
            </span>
          </button>
        </header>
        <div class="card-content" style="height: 200px; overflow: auto">
          <b-table
            :data="selectedRolePermissions"
            :bordered="true"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :mobile-cards="true"
          >
            <b-table-column field="Modulo" label="Módulo" v-slot="props">
              {{ props.row }}
            </b-table-column>
            <template #empty>
              <div class="has-text-centered">No hay permisos asignados</div>
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="isModalViewClubsActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      width="600"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title" style="font-size: large">
            Clubes del Rol
          </p>
          <button
            class="card-header-icon"
            aria-label="close"
            @click="isModalViewClubsActive = false"
          >
            <span class="icon">
              <i class="fas fa-times" aria-hidden="true"></i>
            </span>
          </button>
        </header>
        <div class="card-content" style="height: 200px; overflow: auto">
          <b-table
            :data="selectedRoleClubs"
            :bordered="true"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :mobile-cards="true"
          >
            <b-table-column
              field="Nombre"
              label="Nombre del Club"
              v-slot="props"
            >
              {{ props.row.Nombre }}
            </b-table-column>
            <template #empty>
              <div class="has-text-centered">No hay clubes asignados</div>
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import moment from "moment";
import i18n from "../../utils/i18n";
import ModalCreateRoleSystem from "./ModalCreateRoleSystem.vue";

export default {
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 10,
      hasInput: false,
      paginationOrder: "",
      inputPosition: "",
      inputDebounce: "",
      isBordered: false,
      isStriped: true,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,

      //Loading
      loadingTableList: false,
      loadingButton: false,

      //Data
      systemRoles: [],
      systemRolesFiltered: [],
      filters: {
        Nombre: "",
        Tipo: null,
      },

      //Modals
      ModalCreateRole: false,
      selectedRole: null,
      isModalViewPermissionsActive: false,
      selectedRolePermissions: [],
      isModalViewClubsActive: false,
      selectedRoleClubs: [],

      //i18n
      i18n,
      iso: null,

      //Permissions
      permissions: "",
    };
  },
  created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    //Permissions
    this.permissions = localStorage.getItem("role");

    //
    this.listRoles();
  },
  components: {
    ModalCreateRoleSystem,
  },
  methods: {
    getRoleTypeColor(type) {
      switch (type) {
        case "system":
          return "is-primary"; // Cyan/Turquoise
        case "club":
          return "is-info"; // Blue
        case "admin":
          return "is-danger"; // Red
        case "staff":
          return "is-warning"; // Yellow
        case "user":
          return "is-success"; // Green
        case "agency":
          return "is-link"; // Dark Blue/Purple
        default:
          return "is-light"; // Grey
      }
    },
    findWithFilters() {
      this.systemRolesFiltered = this.systemRoles.filter((role) => {
        const nombreMatch = role.Nombre
          ? role.Nombre.toLowerCase().includes(
              this.filters.Nombre.toLowerCase(),
            )
          : true;
        // const tipoMatch = this.filters.Tipo
        //   ? role.Tipo === this.filters.Tipo
        //   : true;

        return nombreMatch;
      });
    },
    async listRoles() {
      try {
        this.loadingTableList = true;
        const { data } = await axios.post(`${API_URL}/system/list-roles`, {
          // ...this.filters,
        });
        this.systemRoles = data?.roles || [];
        this.systemRolesFiltered = this.systemRoles;
        this.loadingTableList = false;
        this.findWithFilters();
      } catch (err) {
        this.loadingTableList = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar roles",
          type: "is-danger",
        });
      }
    },
    openModalCreateRole() {
      this.selectedRole = null;
      this.ModalCreateRole = true;
    },
    openEditRole(role) {
      this.selectedRole = role;
      this.ModalCreateRole = true;
    },
    openViewPermissions(role) {
      // Assuming role.Permisos is populated. If not, we might need to handle it.
      // Based on ModalCreateRoleSystem logic, it seems it comes populated.
      this.selectedRolePermissions = role.Permisos || [];
      this.isModalViewPermissionsActive = true;
    },
    openViewClubs(role) {
      this.selectedRoleClubs = role.Clubes || [];
      this.isModalViewClubsActive = true;
    },
    async toggleRoleStatus(role) {
      const action = role.Activo ? "Inhabilitar" : "Habilitar";
      const type = role.Activo ? "is-danger" : "is-success";

      this.$buefy.dialog.confirm({
        title: `${action} Rol`,
        message: `¿Estás seguro de que deseas ${action.toLowerCase()} el rol <b>${
          role.Nombre
        }</b>?`,
        confirmText: action,
        type: type,
        hasIcon: true,
        onConfirm: async () => {
          try {
            await axios.put(`${API_URL}/system/update-role/${role._id}`, {
              Activo: !role.Activo,
            });
            this.$buefy.toast.open({
              message: `Rol ${action.toLowerCase()}do correctamente`,
              type: "is-success",
            });
            this.listRoles();
          } catch (err) {
            console.log(err);
            this.$buefy.toast.open({
              message: `Error al ${action.toLowerCase()} rol`,
              type: "is-danger",
            });
          }
        },
      });
    },
  },
};
</script>
